import { render, staticRenderFns } from "./TemplatesModal.vue?vue&type=template&id=5583aba0&"
import script from "./TemplatesModal.vue?vue&type=script&lang=js&"
export * from "./TemplatesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports